<template>
  <div>
    <div>
      <div class="d-flex align-items-center">
        <div>
          <h1 class="page-title">
            <a-icon type="arrow-left" @click="goBack" />
            {{ $t('inventory.goods_receipt.create_title') }}
          </h1>
        </div>
      </div>
    </div>

    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="isDetail ? {} : rules"
      :class="{ info: isDetail }"
    >
      <!-- Detail -->
      <a-card :title="$t('inventory.goods_receipt.detail_gr')" class="w-100 mt-4" :bordered="false">
        <a-row :gutter="24">
          <a-col :span="10">
            <a-form-model-item :label="$t('inventory.goods_receipt.no_gr')" prop="number">
              <a-input
                v-model.trim="form.number"
                size="large"
                autocomplete="off"
                :placeholder="$t('inventory.goods_receipt.no_gr')"
                allow-clear
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('inventory.goods_receipt.gr_date')" prop="date">
              <a-date-picker
                v-model="form.date"
                show-time
                size="large"
                class="w-100"
                :format="dateFormat"
                :placeholder="$t('inventory.goods_receipt.gr_date')"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="10">
            <a-form-model-item :label="$t('inventory.goods_receipt.doc_ref')" prop="reference_number">
              <a-input
                v-model.trim="form.reference_number"
                size="large"
                autocomplete="off"
                :placeholder="$t('inventory.goods_receipt.doc_ref')"
                allow-clear
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('inventory.goods_receipt.warehouse')" prop="warehouse_id" class="mb-0">
              <a-select
                v-model="form.warehouse_id"
                size="large"
                class="select-antd-default"
                :placeholder="$t('inventory.goods_receipt.warehouse')"
                disabled
                style="color: black"
              >
                <a-select-option
                  v-for="item in warehouseList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col v-if="rawResDetailPO" :span="10">
            <a-form-model-item :label="$t('inventory.goods_receipt.po_ref_doc')" prop="supplier_id" class="mb-0">
              <div class="po-number" @click="showModalDetailPO = true">
                {{ rawResDetailPO?.number || '-' }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="10">
            <a-form-model-item :label="$t('inventory.goods_receipt.vendor_name')" prop="supplier_id" class="mb-0">
              <a-input
                v-model.trim="form.supplier_id"
                :disabled="!!rawResDetailPO"
                size="large"
                autocomplete="off"
                :placeholder="$t('inventory.goods_receipt.vendor_name')"
                allow-clear
              />
              <!-- <a-select
                v-model="form.supplier_id"
                size="large"
                class="select-antd-default"
                :placeholder="$t('productAvailability.vendorName')"
                :disabled="isDetail"
              >
                <a-select-option v-for="level in 4" :key="level" :disabled="level != currTier">
                  {{ level }}
                </a-select-option>
              </a-select> -->
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-card>

      <!-- Detail Item Produk -->
      <a-card :title="$t('inventory.goods_receipt.detail_item')" class="w-100 mt-4" :bordered="false">
        <a-row :gutter="24">
          <a-col :span="24">
            <div>
              <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex">
                  <template v-if="isLoading || !!rawResDetailPO">
                    <a-tooltip :title="$t('inventory.goods_receipt.tooltip_cant_add')">
                      <span>
                        <a-button
                          type="primary"
                          :disabled="true"
                          @click="addItem"
                        >
                          {{ $t('inventory.goods_receipt.add_item') }}
                        </a-button>
                      </span>
                    </a-tooltip>
                    <a-tooltip :title="$t('inventory.goods_receipt.tooltip_cant_add')">
                      <span class="ml-2">
                        <a-button
                          type="primary"
                          :disabled="true"
                          @click="showModalBulkItemImport = true"
                        >
                          {{ $t('inventory.goods_receipt.bulk_import') }}
                        </a-button>
                      </span>
                    </a-tooltip>
                  </template>
                  <template v-else>
                    <a-button
                      type="primary"
                      :disabled="false"
                      @click="addItem"
                    >
                      {{ $t('inventory.goods_receipt.add_item') }}
                    </a-button>
                    <a-button
                      class="ml-2"
                      type="primary"
                      :disabled="false"
                      @click="showModalBulkItemImport = true"
                    >
                      {{ $t('inventory.goods_receipt.bulk_import') }}
                    </a-button>
                  </template>
                </div>
                <div>{{ $t('inventory.goods_receipt.total_sku') }}: <b>{{ computedValidSKU || 0 }}</b></div>
              </div>
              <a-table
                :columns="columns"
                :row-key="(record, index) => index"
                :data-source="itemList"
                :loading="isLoading"
                :pagination="false"
                :scroll="{ y: 330, x: 1100 }"
              >
                <template slot="action1" slot-scope="text, record">
                  <div v-if="!rawResDetailPO" @click="onDeleteItem(record)">
                    <TrashIcon style="color: #E00000; cursor:pointer" />
                  </div>
                </template>
                <template slot="catalog_id" slot-scope="text, record">
                  <a-select
                    v-model="record.catalog_id"
                    size="large"
                    class="select-antd-default"
                    style="width: 100%"
                    :placeholder="$t('inventory.goods_receipt.product')"
                    show-search
                    :label-in-value="false"
                    :not-found-content="fetching ? undefined : null"
                    :filter-option="false"
                    :disabled="!!rawResDetailPO"
                    @change="getProductUOM($event, record)"
                    @blur="handleResetSearch"
                    @search="handleSearch"
                  >
                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                    <a-select-option
                      v-for="item in inventories"
                      :key="item.id"
                      :value="`${item.id}.${item.product_id}`"
                      :disabled="selectedSKU.includes(item.sku)"
                    >
                      <div class="d-flex flex-column product-select">
                        <div>{{ item?.title }}</div>
                        <div class="sku-desc">
                          {{ 'SKU : ' + ellipsisText(item?.sku) }}
                        </div>
                      </div>
                    </a-select-option>
                  </a-select>
                </template>
                <template slot="qty_inbound" slot-scope="text, record">
                  <a-input
                    v-if="text"
                    v-model="record.qty_inbound"
                    size="large"
                    placeholder="Qty Inbound"
                    disabled
                  />
                  <template v-else>
                    {{ '-' }}
                  </template>
                </template>
                <template slot="quantity" slot-scope="text, record">
                  <a-form-item
                    :validate-status="record.validateStatus"
                    :help="record.callbackStatus"
                    class="mb-0"
                  >
                    <a-input-number
                      v-model="record.quantity"
                      :disabled="!record.catalog_id"
                      size="large"
                      :min="0"
                      :max="record?.max_quantity || undefined"
                      class="w-100"
                      :placeholder="$t('inventory.goods_receipt.qty')"
                      @change="onChangeQuantity(record.quantity, record)"
                    />
                  </a-form-item>
                </template>
                <template slot="max_quantity" slot-scope="text, record">
                  <a-input
                    v-if="text"
                    v-model="record.max_quantity"
                    size="large"
                    :placeholder="$t('inventory.goods_receipt.max_qty')"
                    disabled
                  />
                  <template v-else>
                    {{ '-' }}
                  </template>
                </template>
                <template slot="uom" slot-scope="text, record">
                  <a-spin :spinning="fetching">
                    <a-input
                      v-model="record.uom"
                      size="large"
                      autocomplete="off"
                      :placeholder="$t('inventory.goods_receipt.uom')"
                      allow-clear
                      disabled
                    />
                    <!-- <a-select
                      v-model="record.uom"
                      size="large"
                      class="select-antd-default"
                      :placeholder="$t('inventory.goods_receipt.uom')"
                      disabled
                      @change="onChangeQuantity(record.quantity, record)"
                    >
                      <a-select-option v-for="level in record.levels" :key="level">
                        {{ level }}
                      </a-select-option>
                    </a-select> -->
                  </a-spin>
                </template>
                <template slot="batch_number" slot-scope="text, record">
                  <a-input
                    v-model="record.batch_number"
                    :disabled="!record.catalog_id"
                    size="large"
                    autocomplete="off"
                    :placeholder="$t('inventory.goods_receipt.batch_no')"
                    allow-clear
                  />
                </template>
                <template slot="expired_date" slot-scope="text, record">
                  <a-date-picker
                    v-model="record.expired_date"
                    :disabled="!record.catalog_id"
                    size="large"
                    class="w-100"
                    :format="dateFormat"
                    :placeholder="$t('inventory.goods_receipt.expired_date')"
                  />
                </template>
                <template slot="stock_type" slot-scope="text, record">
                  <a-select
                    v-model="record.stock_type"
                    size="large"
                    class="select-antd-default"
                    :placeholder="$t('inventory.goods_receipt.stock_type')"
                    :disabled="isDetail || !record.catalog_id"
                  >
                    <a-select-option
                      v-for="item in stockList"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </template>
                <template slot="base_uom" slot-scope="text, record">
                  <a-input
                    v-model="record.base_uom"
                    size="large"
                    autocomplete="off"
                    :placeholder="$t('inventory.goods_receipt.base_uom')"
                    allow-clear
                    disabled
                  />
                </template>
                <template slot="base_quantity" slot-scope="text, record">
                  <a-input
                    v-model="record.base_quantity"
                    size="large"
                    autocomplete="off"
                    :placeholder="$t('inventory.goods_receipt.base_qty')"
                    allow-clear
                    disabled
                  />
                </template>
              </a-table>
            </div>
          </a-col>
        </a-row>
      </a-card>

      <div v-if="!isDetail" class="discount-footer">
        <a-button
          type="primary"
          size="large"
          class="mr-4"
          ghost
          :disabled="isLoading"
          @click="goBack"
        >
          {{ $t('utils.cancel') }}
        </a-button>
        <a-button
          type="primary"
          size="large"
          :loading="isLoading"
          @click="onSubmitGr"
        >
          {{ $route.query.discount_id && !isDuplicate ? $t('utils.edit') : $t('utils.save') }}
        </a-button>
      </div>
    </a-form-model>

    <ModalBulkItemImport
      :is-loading="isLoading"
      :visible="showModalBulkItemImport"
      :max-row="maxRow"
      :total-imported-sku="computedValidSKU"
      :on-close="() => showModalBulkItemImport = false"
      @handleSubmitModal="onNormalizeData"
    />
    <ModalFeedbackAfterImport
      :revised-data="listRevisedBulkItemImport"
      :is-loading="isLoading"
      :visible="showModalFeedbackAfterImport"
      :on-close="() => showModalFeedbackAfterImport = false"
    />
    <ModalDetailPO
      :visible="showModalDetailPO"
      :business-id="businessId"
      :data="rawResDetailPO || {}"
      :disable-auto-fetch="true"
      @onCancel="showModalDetailPO = false"
    />
  </div>
</template>

<script>
import { useInputNumber } from '@/composable/useInputNumber'
import { useDateTime } from '@/composable/useDateTime'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import { getCatalogListGR, getUom, getBaseUom, getProductsByCatalogIds } from '@/api/inventory'
import { getDetailPO } from '@/api/purchase-order'
import debounce from 'lodash/debounce'
import ModalBulkItemImport from '@/views/inventory/goods-receipt/component/ModalBulkItemImport.vue'
import ModalFeedbackAfterImport from '@/views/inventory/goods-receipt/component/ModalFeedbackAfterImport.vue'
import { createGoodsReceipt } from '@/api/good-receive'
import ModalDetailPO from '@/views/purchase-order/modal/ModalDetailPO.vue'

export default {
  name: 'CreateDiscount',
  components: {
    TrashIcon,
    ModalBulkItemImport,
    ModalFeedbackAfterImport,
    ModalDetailPO,
  },
  beforeRouteLeave(to, from, next) {
    // if (this.$route.query.discount_id) {
    //   delete this.$route.query.discount_id
    // }
    next()
  },
  setup() {
    const { numberOnly, toNumber } = useInputNumber()
    const { parseISODate } = useDateTime()
    return { numberOnly, toNumber, parseISODate }
  },
  data() {
    return {
      defaultTier: 1,
      readyTier: 1,
      currTier: 1,
      currQuota: 0,
      sellerId: [],
      idPromo: -1,
      dateFormat: 'DD MMM YYYY HH:mm',
      isLoading: false,
      isDetail: false,
      fetching: false,
      fetchingDetailPO: false,
      endOpen: false,
      visible: false,
      areaAll: false,
      distributorAll: false,
      categoryAll: false,
      customerAll: false,
      itemList: [],
      warehouseList: [],
      inventories: [],
      rules: {},
      initVal: {},
      search: '',
      overlayStyle: {
        width: '100px',
      },
      params: {
        page: 1,
        size: 1000,
      },
      form: {
        number: '',
        reference_number: '',
        supplier_id: '',
        date: null,
        warehouse_id: '',
      },
      stockListRaw: [
        {
          id: 'AV',
          label: 'Available',
          key: 'available',
        },
        {
          id: 'QR',
          label: 'Quarantine',
          key: 'quarantine',
        },
        {
          id: 'DMG',
          label: 'Damage',
          key: 'damage',
        },
        {
          id: 'WIP',
          label: 'Work In Progress',
          key: 'wip',
        },
      ],
      showModalBulkItemImport: false,
      listRevisedBulkItemImport: [],
      showModalFeedbackAfterImport: false,
      maxRow: 150,
      rawResDetailPO: null,
      showModalDetailPO: false,
    }
  },
  computed: {
    businessId() {
      return this.$store.state.user.restriction_base?.toLowerCase() === 'warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id
    },
    business() {
      return Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
    },
    warehouseId() {
      return this.$route.query.warehouse_id || this.$route.query.warehouseId
    },
    warehouses() {
      let list = []
      if (this.$store.state.user.restriction_base?.toLowerCase() === 'warehouse') {
        this.$store.state.user.businessList?.forEach(item => {
          if(!this.warehouseId || (this.warehouseId && item.warehouse_id === this.warehouseId)) {
            list.push(item.warehouse_id)
          }
        })
      }
      return list
    },
    isPrinciple() {
      return ['business owner', 'supervisor', 'store operator', 'principle'].includes(this.$store.state.user.role_name?.toLowerCase())
    },
    selectedSKU() {
      return this.itemList.map((obj2) => obj2.sku)
    },
    computedValidSKU() {
      return this.itemList.filter((obj) => obj.catalog_id)?.length
    },
    stockList() {
      return this.stockListRaw.map(v => ({
        ...v,
        label: this.$t(`inventory.goods_receipt.stock_list.${v.key}`),
      }))
    },
    columns() {
      const baseColumns = [
        {
          title: '',
          dataIndex: 'action1',
          key: 'action1',
          width: 50,
          fixed: 'left',
          scopedSlots: {
            customRender: 'action1',
          },
        },
        {
          title: this.$t('inventory.goods_receipt.product'),
          dataIndex: 'catalog_id',
          key: 'catalog_id',
          fixed: 'left',
          width: 350,
          scopedSlots: {
            customRender: 'catalog_id',
          },
        },
        {
          title: this.$t('inventory.goods_receipt.qty_inbound'),
          dataIndex: 'qty_inbound',
          key: 'qty_inbound',
          width: 120,
          scopedSlots: {
            customRender: 'qty_inbound',
          },
        },
        {
          title: this.$t('inventory.goods_receipt.qty_outstanding'),
          dataIndex: 'max_quantity',
          key: 'max_quantity',
          width: 130,
          scopedSlots: {
            customRender: 'max_quantity',
          },
        },
        {
          title: this.$t('inventory.goods_receipt.qty_gr'),
          dataIndex: 'quantity',
          key: 'quantity',
          width: 120,
          scopedSlots: {
            customRender: 'quantity',
          },
        },
        {
          title: this.$t('inventory.goods_receipt.uom'),
          dataIndex: 'uom',
          key: 'uom',
          width: 110,
          scopedSlots: {
            customRender: 'uom',
          },
        },
      ]

      const endColumns = [
        {
          title: this.$t('inventory.goods_receipt.base_qty'),
          dataIndex: 'base_quantity',
          key: 'base_quantity',
          width: 120,
          scopedSlots: {
            customRender: 'base_quantity',
          },
        },
        {
          title: this.$t('inventory.goods_receipt.base_uom'),
          dataIndex: 'base_uom',
          key: 'base_uom',
          width: 110,
          scopedSlots: {
            customRender: 'base_uom',
          },
        },
      ]

      return [...baseColumns, ...endColumns]
    },
  },
  watch: {
    businessId() {
      this.init()
    },
    warehouseId() {
      this.init()
    },
    search: {
      deep: true,
      immediate: true,
      handler: function () {
        // if (value) {
        this.fetchInventory()
        // }
      },
    },
    '$route.query.po_id': {
      handler(newVal) {
        if (newVal) {
          this.fetchDetailDataPO()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.init()
  },
  methods: {
    fetchDetailDataPO() {
      this.fetchingDetailPO = true
      const poId = this.$route.query.po_id
      if (!poId) {
        this.fetchingDetailPO = false
        return
      }
      getDetailPO({
        business_id: this.businessId,
        id: poId,
      })
      .then(({ data }) => {
        const resData = data?.data
        this.rawResDetailPO = resData
        const { supplier_code } = resData || {}
        this.form.supplier_id = supplier_code || ''
        const listItemPO = []
        resData?.details?.forEach((item) => {
          const { sku, qty, uom, qty_received, catalog_id, base_quantity, base_uom } = item
          const quantity = base_quantity || qty
          const countMaxQuantity = +quantity - (+qty_received || 0)
          if (countMaxQuantity > 0) {
            listItemPO.push({
              sku: sku || '',
              quantity: countMaxQuantity || '',
              uom: base_uom || '',
              max_quantity: countMaxQuantity,
              catalog_id,
              base_quantity,
              base_uom,
            })
          }
        })
        this.onSubmitBulkItemImport(listItemPO)
        this.fetchingDetailPO = false
      })
      .catch(() => {
        this.fetchingDetailPO = false
        this.rawResDetailPO = null
      })
    },
    init: debounce(function() {
      this.getWarehouseList()
      this.fetchInventory()
    }, 500),
    filterOption(input, option) {
      const itemTitle = option.componentOptions.children[0].text;
      const itemSKU = option.componentOptions.children[2].text;
      const keyword = input.toLowerCase();
        
      return (
        itemTitle.toLowerCase().indexOf(keyword) !== -1 ||
        itemSKU.toLowerCase().indexOf(keyword) !== -1
      )
    },
    ellipsisText(text) {
      if(!text) return '-'
      return text.length > 29 ? `${text.substring(0, 26)}...` : text
    },
    async onSubmitGr() {
      if (this.itemList?.map?.(v => v.catalog_id)?.length > this.maxRow) {
        this.$notification.error({
          description: this.$t('inventory.goods_receipt.error_max_item', { max: this.maxRow }),
          message: this.$t('inventory.goods_receipt.failed_save_title'),
        })
        return
      }
      const checkItemList = this.itemList.map((item) => {
        let currentValidateStatus = item.validateStatus
        let currentCallbackStatus = item.callbackStatus
        if (!item.quantity || item.quantity === 0) {
          currentValidateStatus = 'error'
          currentCallbackStatus = this.$t('inventory.goods_receipt.error_qty_empty')
        }
        const newDataObject = {
          ...item,
          validateStatus: currentValidateStatus,
          callbackStatus: currentCallbackStatus,
        }
        return newDataObject
      })
      if (checkItemList?.some(v => v.validateStatus === 'error')) {
        this.itemList = checkItemList
        return
      }
      this.isLoading = true
      const filter = this.warehouseList.filter(v => {return v.value === this.form.warehouse_id})
      const payload = {
        ...this.form,
        business_id: this.businessId,
        reference_id: null,
        reference_type: 'ID',
        inbound_reference: this.rawResDetailPO?.number || null,
        supplier_title: this.form.supplier_id,
        items: this.itemList.map(v => {
          const data = {
            ...v,
            catalog_id: v.catalog_id.split('.')[0],
            item_reference_id: '',
            quantity: Number(v.quantity),
            base_quantity: Number(v.base_quantity),
            levels: undefined,
            units: undefined,
          }
          return data
        }),
      }

      await createGoodsReceipt({
        param: filter[0].wms_categories,
        data: payload,
      })
      .then(() => {
        this.isLoading = false
        this.$notification.success({
          message: this.$t('inventory.goods_receipt.success_save'),
        })
        this.goBack()
      })
      .catch((err) => {
        console.error({err})
        this.$notification.error({
          message: err?.response?.data?.message || this.$t('inventory.goods_receipt.failed_save'),
        })
        this.isLoading = false
      })
    },
    async fetchInventory() {
      this.isLoading = true
      const bodyValue = {
        business_id: this.businessId,
        warehouse_id: this.$route.query.warehouseId,
        search: this.search,
        page: 1,
        limit: 20,
      }
      await getCatalogListGR(bodyValue)
        .then(({ data: { data: response } }) => {
          this.inventories = response
        })
        .catch(err => {
          this.inventories = []
          console.error(err)
        })
        .finally(() => this.isLoading = false)
    },
    handleSearch: debounce(function(e) {
      this.search = e
    }, 500),
    handleResetSearch() {
      this.search = ''
    },
    async getWarehouseList() {
      return await this.$store
        .dispatch('warehouse/GETWAREHOUSELIST', {
          ...this.$route.query,
          business_id: this.businessId,
          warehouse_id: this.warehouses.length
            ? this.warehouses.join()
            : undefined,
          page: 1,
          size: 150,
        })
        .then(response => {
          this.warehouseList = response
          if (this.rawResDetailPO) {
            const findWahsName = this.warehouseList.find(v => v.id === this.rawResDetailPO.warehouse_id)
            this.rawResDetailPO.whs_name = findWahsName?.name || ''
          }
          this.form.warehouse_id = this.$route.query.warehouseId
        })
        .catch(err => {
          console.error(err)
          return err
        })
    },
    async getProductUOM(value, record) {
      const findInventory = this.inventories.find(item => {
        return item.id === value.split('.')[0]
      })
      record.catalog_title = findInventory?.title || ''
      record.sku = findInventory?.sku || ''
      
      this.fetching = true
      await getUom({
        id: value.split('.')[1],
        params: {
          business_id: this.businessId,
        },
      })
      .then(({ data: { data: response } }) => {
        let levels = []
        response.units.forEach((item, index) => {
          levels.push(item.unit)
          record.units[item.unit] = {
            numerator: item.numerator,
            denumerator: item.denumerator,
          }

          if(index == 0) record.uom = item.unit
          if(item.numerator == 1 && item.denumerator == 1) {
            record.uom = item.unit
            record.base_uom = item.unit
          }
        })
        record.levels = levels
      })
      .catch(() => {
        record.uom = ''
        record.base_uom = ''
        record.levels = []
        record.units = {}
      })
      .finally(() => {
        this.fetching = false
      })
    },
    onChangeQuantity(event, record) {
      record.base_quantity = +event * +record.units[record.uom].numerator
      if (record.quantity > 0) {
        record.validateStatus = ''
        record.callbackStatus = ''
      }
    },
    onDeleteItem(record) {
      const filter = this.itemList.filter(v => {return v.item_reference_id !== record.item_reference_id})
      const temp = filter.map((v, i) => {
        const data = {
          ...v,
          item_reference_id: typeof v.item_reference_id === 'string' ? v.item_reference_id : i + 1,
        }
        return data
      })
      this.itemList = temp
    },
    onNormalizeData(importedData) {
      this.isLoading = true
      this.listRevisedBulkItemImport = []
      const normalizeData = []
      importedData.map((obj) => {
        const status = []
        const newObj = Object.fromEntries(
          Object.entries(obj).map(([key, val]) => [key.toLowerCase(), val]),
        );
        const isDuplicatedSKU = normalizeData.find((obj2) => obj2.sku === newObj.sku)
        if (isDuplicatedSKU) {
          return
        }
        if (!/^\d+$/.test(newObj.quantity) || !newObj?.uom || !newObj?.sku) {
          status.push('data_not_valid')
        }
        if (status.length) {
          this.listRevisedBulkItemImport.push({
            ...newObj,
            status: status,
          })
          return
        }
        normalizeData.push(newObj)
      })
      this.onSubmitBulkItemImport(normalizeData)
    },
    async onSubmitBulkItemImport(importedData) {
      const hasCatalogId = importedData.some((item) => item.catalog_id)

      if (hasCatalogId) {
        this.isLoading = true
        try {
          const catalogIds = importedData.map((item) => item.catalog_id).join(',')
          const { data: { data: products } } = await getProductsByCatalogIds({
            business_id: this.businessId,
            params: {
              catalog_id: catalogIds,
              limit: importedData.length,
              page: 1,
              business_id: this.businessId,
            },
          })

          const productIds = products.map((item) => item.product_id).join(',')
          const { data: { data: uomData } } = await getBaseUom({
            business_id: this.businessId,
            params: {
              product_id: productIds,
              business_id: this.businessId,
            },
          })

          const uoms = uomData?.units || []

          importedData.forEach((importItem, index) => {
            const isDuplicatedSKU = this.itemList.find((obj2) => obj2.sku === importItem.sku)
            if (isDuplicatedSKU) {
              return
            }

            const product = products.find((p) => p.id === importItem.catalog_id)
            if (product) {
              const newRecord = {
                item_reference_id: this.itemList.length + index,
                catalog_id: `${product.id}.${product.product_id}`,
                catalog_title: product.title,
                qty_inbound: null,
                quantity: importItem.quantity,
                uom: importItem.uom,
                sku: product.sku,
                batch_number: '',
                expired_date: null,
                stock_type: 'AV',
                base_quantity: importItem?.max_quantity || undefined,
                base_uom: importItem?.base_uom,
                serial_number: '',
                levels: [],
                units: {},
                max_quantity: importItem?.max_quantity || undefined,
              }

              const productUoms = uoms.filter((u) => u.product_id === product.product_id)
              if (productUoms.length) {
                const levels = []
                productUoms.forEach((item) => {
                  levels.push(item.unit)
                  newRecord.units[item.unit] = {
                    numerator: item.numerator,
                    denumerator: item.denumerator,
                  }
                  if (item.numerator === 1 && item.denumerator === 1) {
                    newRecord.uom = item.unit
                    newRecord.base_uom = item.unit
                  }
                })
                newRecord.levels = levels
              } else {
                newRecord.uom = ''
                newRecord.base_uom = ''
                newRecord.levels = []
                newRecord.units = {}
              }

              const isValidUOM = newRecord.levels.find((obj) => obj === newRecord.uom)
              if (isValidUOM) {
                const isExistOnInventories = this.inventories.find((obj) => obj.id === product.id)
                if (!isExistOnInventories) {
                  this.inventories.push(product)
                }
                this.itemList.push(newRecord)
                if (importItem?.base_uom) {
                  newRecord.max_quantity = (+newRecord.max_quantity || 0) / (+newRecord.units[newRecord.uom].numerator || 1)
                  newRecord.qty_inbound = (+importItem?.base_quantity || 0) / (+newRecord.units[newRecord.uom].numerator || 1)
                } else  {
                  this.onChangeQuantity(`${newRecord.quantity}`, newRecord)
                }
              } else {
                this.listRevisedBulkItemImport.push({
                  ...importItem,
                  status: ['uom_not_valid'],
                })
              }
            } else {
              this.listRevisedBulkItemImport.push({
                ...importItem,
                status: ['sku_not_found'],
              })
            }
          })
        } catch (error) {
          console.error(error)
        } finally {
          this.isLoading = false
          if (this.listRevisedBulkItemImport.length) {
            this.showModalFeedbackAfterImport = true
            this.$notification.warning({
              message: 'Beberapa data tidak valid',
            })
          }
        }
        return
      }
      const promises = []
      const tempItemList = this.itemList
      importedData.map((obj) => {
        const isDuplicatedSKU = tempItemList.find((obj2) => obj2.sku === obj.sku)
        if (isDuplicatedSKU) {
          return
        }
        const bodyValue = {
          business_id: this.businessId,
          warehouse_id: this.$route.query.warehouseId,
          search: obj.sku,
          page: 1,
          limit: 20,
        }
        promises.push(
          getCatalogListGR(bodyValue),
        )
      })

      Promise.all(promises)
        .then(async (res) => {
          await Promise.all(res.map(async (obj, index) => {
            const { data, total_row } = obj.data
            if (total_row > 0) {
              const findSpecificCatalog = data.find((item) => item.sku === importedData[index].sku)
              if (findSpecificCatalog) {
                const selecetedCatalog = findSpecificCatalog
                const newRecord = {
                  item_reference_id: tempItemList.length + index,
                  catalog_id: `${selecetedCatalog.id}.${selecetedCatalog.product_id}`,
                  catalog_title: selecetedCatalog.title,
                  quantity: importedData[index].quantity,
                  uom: importedData[index].uom,
                  sku: importedData[index].sku,
                  batch_number: '',
                  expired_date: null,
                  stock_type: 'AV',
                  base_quantity: '',
                  base_uom: '',
                  serial_number: '',
                  levels: [],
                  units: {},
                  max_quantity: importedData[index]?.max_quantity || undefined,
                }
                const { data: { data: uomLevels } } = await getUom({
                  id: selecetedCatalog.product_id,
                  params: {
                    business_id: this.businessId,
                  },
                })
                if (uomLevels) {
                  let levels = []
                  uomLevels.units.forEach((item, index) => {
                    levels.push(item.unit)
                    newRecord.units[item.unit] = {
                      numerator: item.numerator,
                      denumerator: item.denumerator,
                    }
                    if(item.numerator == 1 && item.denumerator == 1) {
                      newRecord.uom = item.unit
                      newRecord.base_uom = item.unit
                    }
                  })
                  newRecord.levels = levels
                } else {
                  newRecord.uom = ''
                  newRecord.base_uom = ''
                  newRecord.levels = []
                  newRecord.units = {}
                }
                const isValidUOM = newRecord.levels.find((obj) => obj === newRecord.uom)
                if (isValidUOM) {
                  const isExistOnInventories = this.inventories.find((obj) => obj.id === selecetedCatalog.id)
                  if (!isExistOnInventories) {
                    this.inventories.push(selecetedCatalog)
                  }
                  this.itemList.push(newRecord)
                  this.onChangeQuantity(`${newRecord.quantity}`, newRecord)
                } else {
                  this.listRevisedBulkItemImport.push({
                    ...importedData[index],
                    status: ['uom_not_valid'],
                  })
                }
              } else {
                this.listRevisedBulkItemImport.push({
                  ...importedData[index],
                  status: ['sku_not_found'],
                })
              }
            } else {
              this.listRevisedBulkItemImport.push({
                ...importedData[index],
                status: ['sku_not_found'],
              })
            }
          }))
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.showModalBulkItemImport = false
          this.isLoading = false
          if (this.listRevisedBulkItemImport.length) {
            this.showModalFeedbackAfterImport = true
            this.$notification.warning({
              message: 'Beberapa data tidak valid',
            })
          } else {
            this.$notification.success({
              message: 'Semua Data Berhasil di Import',
            })
          }
        })
    },
    addItem() {
      const arr = this.itemList
      const temp = {
        item_reference_id: arr.length + 1,
        catalog_id: '',
        catalog_title: '',
        qty_inbound: null,
        quantity: '',
        uom: '',
        sku: '',
        batch_number: '',
        expired_date: null,
        stock_type: 'AV',
        base_quantity: '',
        base_uom: '',
        serial_number: '',
        levels: [],
        units: {},
        max_quantity: null,
      }
      arr.push(temp)
      this.itemList = arr
    },
    goBack() {
      this.$router.back({
        path: '/inventory/goods-receipt',
        query: { ...this.$route.query },
      })
    },
  },
}
</script>

<style lang="scss">
@import './create.module.scss';

.ant-select-disabled .ant-select-selection {
  color: #1a1a1a !important;
}
</style>
<style lang="scss" scoped>
.ant-select-lg .ant-select-selection--single .product-select {
  white-space: nowrap !important;
}
.product-select {
  white-space: pre-wrap !important;
  .sku-desc {
    font-size: 12px;
    font-weight: 500;
  }
}
.po-number {
  color: var(--kit-color-primary);
  &:hover {
    text-decoration: underline;
    cursor: pointer;
    width: max-content;
  }
}
</style>